

export function inputEmail_blur(event) {
    setTimeout(() => {
        let emailValidMsg = ''; 
        if(!$w('#inputEmail').valid){
            emailValidMsg += 'בבקשה להכניס כתובת מייל תקינה'
        }else{
            emailValidMsg += ''
        }
        $w('#emailErrorMsg').text = emailValidMsg;
        $w('#emailErrorMsg').expand();
	//Add your code for this event here: 
    },5);
}

export function inputPhone_blur(event) {
	setTimeout(() => {
        let phoneValidMsg = ''; 
        let regExp = new RegExp('[0-9]{8,10}');
        let val = $w('#inputPhone').value;
        if (val == '' || regExp.test(val)){
            phoneValidMsg += ''
        }else{
            phoneValidMsg += 'בבקשה להכניס מספר טלפון תקין'
        }
        $w('#phoneErrorMsg').text = phoneValidMsg;
        $w('#phoneErrorMsg').expand();
    },5); 
}